import { render, staticRenderFns } from "./more-dropdown.vue?vue&type=template&id=33274a1c&"
import script from "./more-dropdown.vue?vue&type=script&lang=js&"
export * from "./more-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./more-dropdown.vue?vue&type=style&index=0&id=33274a1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports